package it.neckar.lizergy.model.project.process.state

import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.lizergy.model.project.process.state.AssemblyBasementPreparationProcessStateEntry.AssemblyBasementPreparationProcessStates.Cancelled
import it.neckar.lizergy.model.project.process.state.AssemblyBasementPreparationProcessStateEntry.AssemblyBasementPreparationProcessStates.Done
import it.neckar.lizergy.model.project.process.state.AssemblyBasementPreparationProcessStateEntry.AssemblyBasementPreparationProcessStates.InProgress
import it.neckar.lizergy.model.project.process.state.AssemblyBasementPreparationProcessStateEntry.AssemblyBasementPreparationProcessStates.Missing
import it.neckar.open.i18n.I18nConfiguration
import it.neckar.open.kotlin.serializers.IsoMillis
import it.neckar.processStates.HasDueDate
import it.neckar.processStates.ProcessStateEntryId
import it.neckar.processStates.ProcessStatePhase
import it.neckar.user.UserLoginName
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("AssemblyBasementPreparationProcessStateEntry")
data class AssemblyBasementPreparationProcessStateEntry(
  override val id: ProcessStateEntryId,
  override val processState: AssemblyBasementPreparationProcessStates,
  override val assignedTo: UserLoginName,
  override val belongsTo: CompanyCode,
  override val dueDate: IsoMillis?,
  override val assignedAt: IsoMillis,
  override val assignedBy: UserLoginName,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : LizergyProcessStateEntry, HasDueDate {

  override val availableOptions: List<AssemblyBasementPreparationProcessStates>
    get() = AssemblyBasementPreparationProcessStates.entries

  override fun format(i18nConfiguration: I18nConfiguration): String {
    return when (processState) {
      Missing -> processState.formatForScheduling(dueDate, i18nConfiguration)
      InProgress, Done, Cancelled -> processState.format(i18nConfiguration)
    }
  }

  @Serializable
  @SerialName("AssemblyBasementPreparationProcessStates")
  enum class AssemblyBasementPreparationProcessStates : LizergyProcessStates {
    Missing,
    InProgress,
    Done,
    Cancelled,

    ;

    override val inPhase: ProcessStatePhase
      get() = when (this) {
        Missing -> ProcessStatePhase.Untouched
        InProgress -> ProcessStatePhase.InProgress
        Done -> ProcessStatePhase.Done
        Cancelled -> ProcessStatePhase.Rejected
      }

    override fun format(i18nConfiguration: I18nConfiguration): String {
      return when (this) {
        Missing -> "MK"
        InProgress -> "MK Material fehlt"
        Done -> "MK Material vorbereitet"
        Cancelled -> "MK abgesagt"
      }
    }
  }
}
